<div class="aca-admin aca-wz">
  <aca-page-header icon="play_circle" [title]="'DMS.WIZARD.TITLE' | translate" [subtitle]="'DMS.WIZARD.SUBTITLE' | translate" />

  <!-- ── stepper ──────────────────────────────────────────────────────────── -->
  <ol class="aca-wz__steps">
    <li *ngFor="let s of steps" class="aca-wz__step" [ngClass]="stepClass(s.n)">
      <span class="aca-wz__stepnum">
        <mat-icon *ngIf="s.n < step()">check</mat-icon>
        <ng-container *ngIf="s.n >= step()">{{ s.n }}</ng-container>
      </span>
      <span class="aca-wz__steplabel">{{ s.key | translate }}</span>
    </li>
  </ol>

  <mat-progress-bar mode="indeterminate" *ngIf="loadingDefs() || starting()" />

  <!-- ══ STEP 1 · pick a workflow ══════════════════════════════════════════ -->
  <ng-container *ngIf="step() === 1">
    <div class="aca-wz__filters">
      <label class="aca-wz__search">
        <mat-icon>search</mat-icon>
        <input type="search" [(ngModel)]="search" [placeholder]="'DMS.WIZARD.SEARCH' | translate" />
      </label>
      <select class="aca-wz__select" [(ngModel)]="category" [attr.aria-label]="'DMS.WIZARD.CATEGORY' | translate">
        <option value="">{{ 'DMS.WIZARD.ALL_CATEGORIES' | translate }}</option>
        <option *ngFor="let c of categories()" [value]="c">{{ c }}</option>
      </select>
      <select class="aca-wz__select" [(ngModel)]="statusFilter" [attr.aria-label]="'DMS.WIZARD.STATUS' | translate">
        <option value="all">{{ 'DMS.WIZARD.STATUS_ALL' | translate }}</option>
        <option value="ready">{{ 'DMS.WIZARD.STATUS_READY' | translate }}</option>
      </select>
    </div>

    <aca-page-state
      *ngIf="!loadingDefs() && !filtered().length"
      state="empty"
      icon="account_tree"
      [title]="'DMS.WIZARD.EMPTY_TITLE' | translate"
      [message]="'DMS.WIZARD.EMPTY_HINT' | translate"
    />

    <div class="aca-wz__grid">
      <article *ngFor="let card of filtered()" class="aca-wz__card" [class.aca-wz__card--on]="selected()?.id === card.id">
        <header class="aca-wz__cardhead">
          <span class="aca-wz__cardicon"><mat-icon>account_tree</mat-icon></span>
          <span class="aca-wz__chips">
            <span class="aca-wz__chip aca-wz__chip--cat">{{ card.category }}</span>
            <span class="aca-wz__chip aca-wz__chip--ok">{{ 'DMS.WIZARD.ACTIVE' | translate }}</span>
          </span>
        </header>
        <h3 class="aca-wz__cardname">{{ card.name }}</h3>
        <p class="aca-wz__carddesc">{{ card.description || ('DMS.WIZARD.NO_DESCRIPTION' | translate) }}</p>
        <dl class="aca-wz__cardmeta">
          <div>
            <dt>{{ 'DMS.WIZARD.STEPS' | translate }}</dt>
            <dd>{{ card.steps }}</dd>
          </div>
          <div>
            <dt>SLA</dt>
            <dd>{{ card.slaDays ? ('DMS.WIZARD.SLA_DAYS' | translate: { p0: card.slaDays }) : '—' }}</dd>
          </div>
          <div>
            <dt>{{ 'DMS.WIZARD.VERSION' | translate }}</dt>
            <dd>v{{ card.version }}</dd>
          </div>
        </dl>
        <footer class="aca-wz__cardfoot">
          <button type="button" class="aca-wz__selectbtn" [class.aca-wz__selectbtn--on]="selected()?.id === card.id" (click)="pick(card)">
            <mat-icon>{{ selected()?.id === card.id ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            {{ (selected()?.id === card.id ? 'DMS.WIZARD.SELECTED' : 'DMS.WIZARD.SELECT') | translate }}
          </button>
        </footer>
      </article>
    </div>
  </ng-container>

  <!-- ══ STEP 2 · upload documents ═════════════════════════════════════════ -->
  <ng-container *ngIf="step() === 2">
    <div class="aca-wz__upload">
      <section class="aca-wz__queue">
        <div
          class="aca-wz__drop"
          [class.aca-wz__drop--over]="dragging()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <mat-icon>cloud_upload</mat-icon>
          <p>{{ 'DMS.WIZARD.DROP' | translate }}</p>
          <button type="button" class="aca-wz__outline" (click)="fileInput.click()">{{ 'DMS.WIZARD.BROWSE' | translate }}</button>
          <input #fileInput type="file" multiple hidden [accept]="accept" (change)="onFileInput($event)" />
        </div>

        <ul class="aca-wz__filelist" *ngIf="queue().length">
          <li *ngFor="let q of queue(); let i = index" class="aca-wz__file" [class.aca-wz__file--on]="selectedIndex() === i">
            <button type="button" class="aca-wz__filebtn" (click)="viewFile(i)">
              <span class="aca-wz__badge">{{ badge(q.file) }}</span>
              <span class="aca-wz__filemain">
                <span class="aca-wz__filename">{{ q.file.name }}</span>
                <span class="aca-wz__filemeta">
                  {{ sizeLabel(q.file.size) }}
                  <span class="aca-wz__chip aca-wz__chip--primary" *ngIf="q.role === 'primary'">{{ 'DMS.WIZARD.PRIMARY' | translate }}</span>
                  <span class="aca-wz__chip" *ngIf="q.nodeId">{{ 'DMS.WIZARD.IN_REPO' | translate }}</span>
                </span>
              </span>
            </button>
            <span class="aca-wz__fileactions">
              <button
                mat-icon-button
                type="button"
                *ngIf="q.role !== 'primary'"
                [matTooltip]="'DMS.WIZARD.MAKE_PRIMARY' | translate"
                [attr.aria-label]="'DMS.WIZARD.MAKE_PRIMARY' | translate"
                (click)="makePrimary(i)"
              >
                <mat-icon>star_border</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                [matTooltip]="'DMS.WIZARD.REMOVE' | translate"
                [attr.aria-label]="'DMS.WIZARD.REMOVE' | translate"
                (click)="removeFile(i)"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </span>
          </li>
        </ul>
      </section>

      <section class="aca-wz__previewpane">
        <app-local-file-preview *ngIf="selectedFile()?.file?.size; else noPreview" [file]="selectedFile()!.file" />
        <ng-template #noPreview>
          <div class="aca-wz__nopreview">
            <mat-icon>find_in_page</mat-icon>
            <p>{{ (selectedFile() ? 'DMS.WIZARD.PREVIEW_REPO' : 'DMS.WIZARD.PREVIEW_EMPTY') | translate }}</p>
            <p class="aca-wz__nopreviewname" *ngIf="selectedFile()">{{ selectedFile()!.file.name }}</p>
          </div>
        </ng-template>
      </section>
    </div>
  </ng-container>

  <!-- ══ STEP 3 · metadata + workflow data — one sheet, two columns ════════ -->
  <ng-container *ngIf="step() === 3">
    <section class="aca-wz__sheet">
      <header class="aca-wz__sheethead">
        <span class="aca-wz__sheeticon"><mat-icon>description</mat-icon></span>
        <span class="aca-wz__sheettext">
          <h3>{{ 'DMS.WIZARD.STEP3_TITLE' | translate }}</h3>
          <p>{{ 'DMS.WIZARD.STEP3_SUB' | translate }}</p>
        </span>
      </header>

      <div class="aca-wz__cols">
        <div class="aca-wz__col">
          <h4 class="aca-wz__colhead"><mat-icon>description</mat-icon>{{ 'DMS.WIZARD.DOC_INFO' | translate }}</h4>

          <label class="aca-wz__field">
            <span>{{ 'DMS.WIZARD.DOC_TITLE' | translate }} <em>*</em></span>
            <input
              type="text"
              data-automation-id="dms-wz-title"
              [(ngModel)]="meta.title"
              [class.aca-wz__input--err]="touched() && !meta.title.trim()"
            />
          </label>
          <label class="aca-wz__field">
            <span>{{ 'DMS.WIZARD.DOC_CODE' | translate }}</span>
            <input type="text" [(ngModel)]="meta.documentCode" />
            <small class="aca-wz__help">{{ 'DMS.WIZARD.DOC_CODE_HELP' | translate }}</small>
          </label>
          <label class="aca-wz__field">
            <span>{{ 'DMS.WIZARD.DOC_TYPE' | translate }} <em>*</em></span>
            <span class="aca-wz__control">
              <mat-icon>description</mat-icon>
              <select
                data-automation-id="dms-wz-doctype"
                [(ngModel)]="meta.documentType"
                [class.aca-wz__input--err]="touched() && !meta.documentType"
              >
                <option value="">—</option>
                <option *ngFor="let o of documentTypes" [value]="o.value">{{ o.label | translate }}</option>
              </select>
            </span>
          </label>
          <label class="aca-wz__field">
            <span>{{ 'DMS.WIZARD.DEPARTMENT' | translate }} <em>*</em></span>
            <span class="aca-wz__control">
              <mat-icon>apartment</mat-icon>
              <input
                type="text"
                data-automation-id="dms-wz-department"
                [(ngModel)]="meta.department"
                [class.aca-wz__input--err]="touched() && !meta.department.trim()"
              />
            </span>
          </label>
          <label class="aca-wz__field">
            <span>{{ 'DMS.WIZARD.DOC_DATE' | translate }} <em>*</em></span>
            <aca-date-input
              data-automation-id="dms-wz-docdate"
              [(ngModel)]="meta.documentDate"
              [class.aca-wz__input--err]="touched() && !meta.documentDate"
            />
          </label>
          <label class="aca-wz__field">
            <span>
              {{ 'DMS.WIZARD.CONFIDENTIALITY' | translate }}
              <mat-icon class="aca-wz__hint" [matTooltip]="'DMS.WIZARD.CONF_HINT' | translate">info</mat-icon>
            </span>
            <select [(ngModel)]="meta.confidentiality">
              <option value="">—</option>
              <option *ngFor="let o of confidentialities" [value]="o.value">{{ o.label | translate }}</option>
            </select>
          </label>

          <div class="aca-wz__field" *ngFor="let f of extraFields()">
            <label [attr.for]="'wz-extra-' + f.id">{{ fieldLabel(f) | translate }} <em *ngIf="f.mandatory">*</em></label>
            <span class="aca-wz__control">
              <mat-icon>{{ fieldIcon(f) }}</mat-icon>
              <ng-container [ngSwitch]="inputKind(f)">
                <select *ngSwitchCase="'list'" [id]="'wz-extra-' + f.id" [(ngModel)]="extra[f.id]" [name]="f.id">
                  <option value="">—</option>
                  <option *ngFor="let o of f.options" [value]="o.value">{{ o.label | translate }}</option>
                </select>
                <select *ngSwitchCase="'boolean'" [id]="'wz-extra-' + f.id" [(ngModel)]="extra[f.id]" [name]="f.id">
                  <option value="">—</option>
                  <option value="true">{{ 'DMS.UI.2726B4' | translate }}</option>
                  <option value="false">{{ 'DMS.UI.19CE3F' | translate }}</option>
                </select>
                <aca-date-input *ngSwitchCase="'date'" [inputId]="'wz-extra-' + f.id" [(ngModel)]="extra[f.id]" [name]="f.id" />
                <input *ngSwitchCase="'number'" [id]="'wz-extra-' + f.id" type="number" step="any" [(ngModel)]="extra[f.id]" [name]="f.id" />
                <input *ngSwitchDefault [id]="'wz-extra-' + f.id" type="text" [(ngModel)]="extra[f.id]" [name]="f.id" />
              </ng-container>
            </span>
          </div>

          <label class="aca-wz__field">
            <span>{{ 'DMS.WIZARD.DESCRIPTION' | translate }}</span>
            <textarea rows="3" maxlength="1000" [(ngModel)]="meta.description"></textarea>
            <small class="aca-wz__count">{{ (meta.description || '').length }}/1,000 {{ 'DMS.WIZARD.CHARS' | translate }}</small>
          </label>
        </div>

        <div class="aca-wz__col">
          <h4 class="aca-wz__colhead"><mat-icon>settings</mat-icon>{{ 'DMS.WIZARD.FLOW_INFO' | translate }}</h4>

          <label class="aca-wz__field">
            <span>{{ 'DMS.WIZARD.APPROVAL_TYPE' | translate }} <em>*</em></span>
            <span class="aca-wz__control">
              <mat-icon>account_tree</mat-icon>
              <select [ngModel]="selected()?.id" (ngModelChange)="pickById($event)">
                <option *ngFor="let c of cards()" [value]="c.id">{{ c.name }}</option>
              </select>
            </span>
          </label>
          <label class="aca-wz__field" *ngIf="needsAssignee() !== 'none'">
            <span>{{ (needsAssignee() === 'group' ? 'DMS.WIZARD.ASSIGN_GROUP' : 'DMS.WIZARD.ASSIGN_PERSON') | translate }} <em>*</em></span>
            <span class="aca-wz__assignee">
              <input type="text" readonly [value]="assigneeLabel || assignee" [class.aca-wz__input--err]="touched() && !assignee" />
              <button type="button" class="aca-wz__outline" (click)="pickAssignee()"><mat-icon>person_search</mat-icon></button>
            </span>
          </label>
          <label class="aca-wz__field">
            <span>{{ 'DMS.WIZARD.PRIORITY' | translate }} <em>*</em></span>
            <span class="aca-wz__control">
              <mat-icon>flag</mat-icon>
              <select [(ngModel)]="flow.priority">
                <option [ngValue]="1">{{ 'DMS.WIZARD.P_HIGH' | translate }}</option>
                <option [ngValue]="2">{{ 'DMS.WIZARD.P_MEDIUM' | translate }}</option>
                <option [ngValue]="3">{{ 'DMS.WIZARD.P_LOW' | translate }}</option>
              </select>
            </span>
          </label>
          <label class="aca-wz__field">
            <span>{{ 'DMS.WIZARD.SLA_DUE' | translate }} <em>*</em></span>
            <aca-date-input data-automation-id="dms-wz-due" [(ngModel)]="flow.dueAt" [class.aca-wz__input--err]="touched() && !flow.dueAt" />
            <small class="aca-wz__help">{{ 'DMS.WIZARD.SLA_HELP' | translate }}</small>
          </label>
          <label class="aca-wz__field">
            <span>{{ 'DMS.WIZARD.NOTE' | translate }}</span>
            <textarea rows="4" maxlength="500" [(ngModel)]="flow.message"></textarea>
            <small class="aca-wz__count">{{ (flow.message || '').length }}/500 {{ 'DMS.WIZARD.CHARS' | translate }}</small>
          </label>

          <div class="aca-wz__attach">
            <div class="aca-wz__attachhead">
              <h4 class="aca-wz__colhead"><mat-icon>attach_file</mat-icon>{{ 'DMS.WIZARD.ATTACHMENTS' | translate }}</h4>
              <button type="button" class="aca-wz__addatt" (click)="attachInput.click()">
                <mat-icon>add</mat-icon>{{ 'DMS.WIZARD.ADD_ATTACHMENT' | translate }}
              </button>
              <input #attachInput type="file" multiple hidden [accept]="accept" (change)="onFileInput($event)" />
            </div>
            <ul class="aca-wz__attlist" *ngIf="queue().length">
              <li *ngFor="let q of queue(); let i = index">
                <span class="aca-wz__tile aca-wz__tile--{{ fileTone(q.file) }}">{{ badge(q.file) }}</span>
                <span class="aca-wz__attmain">
                  <span class="aca-wz__filename">
                    {{ q.file.name }}
                    <span class="aca-wz__chip aca-wz__chip--primary" *ngIf="q.role === 'primary'">{{ 'DMS.WIZARD.PRIMARY' | translate }}</span>
                  </span>
                  <span class="aca-wz__filemeta">{{ sizeLabel(q.file.size) }} • {{ q.file.lastModified | acaDate: 'd MMM y HH:mm' }}</span>
                </span>
                <button
                  mat-icon-button
                  type="button"
                  [matTooltip]="'DMS.WIZARD.REMOVE' | translate"
                  [attr.aria-label]="'DMS.WIZARD.REMOVE' | translate"
                  (click)="removeFile(i)"
                >
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <!-- ══ STEP 4 · review + start ═══════════════════════════════════════════ -->
  <ng-container *ngIf="step() === 4">
    <div class="aca-wz__review">
      <section class="aca-wz__panel">
        <h3 class="aca-wz__paneltitle"><mat-icon>account_tree</mat-icon>{{ 'DMS.WIZARD.SUMMARY_FLOW' | translate }}</h3>
        <dl class="aca-wz__props">
          <dt>{{ 'DMS.WIZARD.WORKFLOW' | translate }}</dt>
          <dd>{{ selected()?.name }}</dd>
          <dt>{{ 'DMS.WIZARD.VERSION' | translate }}</dt>
          <dd>v{{ selected()?.version }}</dd>
          <dt>{{ 'DMS.WIZARD.STEPS' | translate }}</dt>
          <dd>{{ selected()?.steps }}</dd>
          <dt>SLA</dt>
          <dd>{{ selected()?.slaDays ? ('DMS.WIZARD.SLA_DAYS' | translate: { p0: selected()!.slaDays }) : '—' }}</dd>
          <dt>{{ 'DMS.WIZARD.DUE' | translate }}</dt>
          <dd>{{ flow.dueAt || '—' }}</dd>
          <dt>{{ 'DMS.WIZARD.PRIORITY' | translate }}</dt>
          <dd>{{ priorityLabel() | translate }}</dd>
        </dl>

        <h3 class="aca-wz__paneltitle"><mat-icon>folder_open</mat-icon>{{ 'DMS.WIZARD.SUMMARY_DOCS' | translate }}</h3>
        <ul class="aca-wz__doclist">
          <li *ngFor="let q of queue()">
            <span class="aca-wz__badge">{{ badge(q.file) }}</span>
            <span class="aca-wz__docname">{{ q.file.name }}</span>
            <span class="aca-wz__docsize">{{ sizeLabel(q.file.size) }}</span>
            <span class="aca-wz__chip aca-wz__chip--primary" *ngIf="q.role === 'primary'">{{ 'DMS.WIZARD.PRIMARY' | translate }}</span>
          </li>
        </ul>

        <h3 class="aca-wz__paneltitle"><mat-icon>list_alt</mat-icon>{{ 'DMS.WIZARD.SUMMARY_META' | translate }}</h3>
        <dl class="aca-wz__props">
          <dt>{{ 'DMS.WIZARD.DOC_TITLE' | translate }}</dt>
          <dd>{{ meta.title }}</dd>
          <dt>{{ 'DMS.WIZARD.DOC_TYPE' | translate }}</dt>
          <dd>{{ docTypeLabel() | translate }}</dd>
          <dt>{{ 'DMS.WIZARD.DOC_DATE' | translate }}</dt>
          <dd>{{ meta.documentDate }}</dd>
          <dt>{{ 'DMS.WIZARD.DEPARTMENT' | translate }}</dt>
          <dd>{{ meta.department || '—' }}</dd>
        </dl>
      </section>

      <aside class="aca-wz__panel aca-wz__path">
        <h3 class="aca-wz__paneltitle"><mat-icon>alt_route</mat-icon>{{ 'DMS.WIZARD.PATH' | translate }}</h3>
        <ol class="aca-wz__flow">
          <li class="aca-wz__flownode aca-wz__flownode--start">
            <span class="aca-wz__flowname">{{ 'DMS.WIZARD.FLOW_START' | translate }}</span>
          </li>
          <li *ngFor="let s of pathPreview()" class="aca-wz__flownode" [class.aca-wz__flownode--task]="s.type === 'task'">
            <span class="aca-wz__flowname">{{ s.name }}</span>
            <span class="aca-wz__flowwho">{{ s.who }}</span>
          </li>
          <li class="aca-wz__flownode aca-wz__flownode--end">
            <span class="aca-wz__flowname">{{ 'DMS.WIZARD.FLOW_END' | translate }}</span>
          </li>
        </ol>
      </aside>
    </div>
  </ng-container>

  <!-- ── footer nav ───────────────────────────────────────────────────────── -->
  <footer class="aca-wz__nav">
    <button type="button" class="aca-wz__outline" *ngIf="step() > 1" (click)="back()" [disabled]="starting()">
      <mat-icon>arrow_back</mat-icon>{{ 'DMS.WIZARD.BACK' | translate }}
    </button>
    <span class="aca-wz__navspace"></span>
    <button
      type="button"
      class="aca-wz__primary"
      *ngIf="step() < 4"
      (click)="next()"
      [disabled]="(step() === 1 && !selected()) || (step() === 2 && !queue().length)"
    >
      {{ 'DMS.WIZARD.NEXT' | translate }}<mat-icon>arrow_forward</mat-icon>
    </button>
    <button type="button" class="aca-wz__primary aca-wz__primary--go" *ngIf="step() === 4" (click)="start()" [disabled]="starting()">
      <mat-icon>play_arrow</mat-icon>{{ 'DMS.WIZARD.START' | translate }}
    </button>
  </footer>
</div>
